import * as React from 'react';

interface InsightsFlexContainerProps {
  children: React.ReactNode;
}

export function InsightsFlexContainer({
  children,
}: InsightsFlexContainerProps) {
  return (
    <div className="flex sm:flex-row flex-col items-start sm:items-center p-4 gap-4 min-h-20">
      {children}
    </div>
  );
}
